import React, { useState } from "react";
import { Button } from "primereact/button";
import veglabel from "../../assets/images/icon/veg.png";
import nonveg from "../../assets/images/non-vegetarian-sign-veg-logo-symbol-vector-50890043.jpg";
import "./OrderCard.css"; // Make sure to import the CSS

const Ordercard = ({ serviceType, data, onCancel, eventId }) => {
  const [expandedIndexes, setExpandedIndexes] = useState({});
  const [openMenuRow, setOpenMenuRow] = useState(null);

  const toggleExpand = (idx) => {
    setExpandedIndexes((prev) => ({
      ...prev,
      [idx]: !prev[idx],
    }));
  };

  const formatCurrency = (amount) => {
    if (amount == null) return "₹0";
    return `₹${Math.round(amount).toLocaleString()}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    if (isNaN(date)) return "N/A";
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  if (!data || data.length === 0) return null;

  // ============================================
  // VENUE CASE
  // ============================================
  if (serviceType === "Venue") {
    return (
      <div className="Order_service-card">
        {data.map((venue, idx) => {
          const isExpanded = expandedIndexes[idx];
          const venueData = venue.venue || {};
          const sectionData = venue.section || {};
          const providerData = venue.provider || {};
          const pricing = venue.pricing || {};

          return (
            <div key={idx} className="Order_service-item venue-order-item">
              <div className="order_headder">
                <div className="venue-info">
                  <span className="providername">{venueData.name || "Venue"}</span>
                  <span className="section-tag">{sectionData.name || "Section"}</span>
                </div>
                <div className="cancleblock">
                  <div style={{ position: "relative" }}>
                    <Button
                      icon="pi pi-ellipsis-v"
                      className="p-button-rounded p-button-text"
                      style={{ backgroundColor: "#fff", color: "#000", border: "1px solid #ccc" }}
                      onClick={() =>
                        setOpenMenuRow(openMenuRow === venue.provider_id ? null : venue.provider_id)
                      }
                    />
                    {openMenuRow === venue.provider_id && (
                      <div
                        className="dropdownContainer"
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: 0,
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "5px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          zIndex: 100,
                          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        }}
                      >
                        <button
                          className="cancel-btn"
                          onClick={() => {
                            onCancel({ eventId, provider_id: venue.provider_id, serviceType });
                            setOpenMenuRow(null);
                          }}
                        >
                          <i className="pi pi-times"></i> Cancel
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Venue Details */}
              <div className="venue-details-grid">
                <div className="detail-row">
                  <span className="label">Provider:</span>
                  <span className="value">{providerData.name || "N/A"}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Pricing Type:</span>
                  <span className="value">{venue.pricingType || "N/A"}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Guests:</span>
                  <span className="value">{venue.noOfGuests || venue.guest_count || "N/A"}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Capacity:</span>
                  <span className="value">
                    {sectionData.minCapacity} - {sectionData.maxCapacity}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="label">From:</span>
                  <span className="value">
                    {formatDate(venue.fromDate || venue.from_date)}
                    {venue.fromTime && ` ${venue.fromTime}`}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="label">To:</span>
                  <span className="value">
                    {formatDate(venue.toDate || venue.to_date)}
                    {venue.toTime && ` ${venue.toTime}`}
                  </span>
                </div>
                {venue.booking_date && (
                  <div className="detail-row">
                    <span className="label">Booking Date:</span>
                    <span className="value">{formatDate(venue.booking_date)}</span>
                  </div>
                )}
                {venue.start_time && venue.end_time && (
                  <div className="detail-row">
                    <span className="label">Timing:</span>
                    <span className="value">{venue.start_time} - {venue.end_time}</span>
                  </div>
                )}
              </div>

              {/* Food Selections */}
              {venue.foodSelections && venue.foodSelections.length > 0 && (
                <div className="selections-section">
                  <span className="selections-title">🍽️ Food Selections</span>
                  {venue.foodSelections.map((food, fIdx) => (
                    <div key={fIdx} className="selection-row">
                      <span>{food.menu?.name || `Menu ${food.menuId}`}</span>
                      <span>{food.guestCount} guests</span>
                      <span>{formatCurrency(food.subtotal)}</span>
                    </div>
                  ))}
                </div>
              )}

              {/* Drink Selections */}
              {venue.drinkSelections && venue.drinkSelections.length > 0 && (
                <div className="selections-section">
                  <span className="selections-title">🍷 Drink Selections</span>
                  {venue.drinkSelections.map((drink, dIdx) => (
                    <div key={dIdx} className="selection-row">
                      <span>{drink.drinkOption?.name || `Drink ${drink.drinkOptionId}`}</span>
                      <span>{drink.guestCount} guests</span>
                      <span>{formatCurrency(drink.subtotal)}</span>
                    </div>
                  ))}
                </div>
              )}

              {/* Pricing Breakdown */}
              <div className="pricing-breakdown">
                {pricing.basePrice > 0 && (
                  <div className="price-row">
                    <span>Base Price:</span>
                    <span>{formatCurrency(pricing.basePrice)}</span>
                  </div>
                )}
                {venue.foodTotal > 0 && (
                  <div className="price-row">
                    <span>Food Total:</span>
                    <span>{formatCurrency(venue.foodTotal)}</span>
                  </div>
                )}
                {venue.drinkTotal > 0 && (
                  <div className="price-row">
                    <span>Drink Total:</span>
                    <span>{formatCurrency(venue.drinkTotal)}</span>
                  </div>
                )}
                <div className="price-row">
                  <span>GST ({pricing.gst_percentage || pricing.gstPercentage || 18}%):</span>
                  <span>{formatCurrency(pricing.gst_amount || pricing.gstAmount || 0)}</span>
                </div>
              </div>

              <div className="footer">
                <span></span>
                <span className="Bill_total">Bill Total {formatCurrency(venue.total_amount || venue.totalAmount || 0)}</span>
              </div>

              {/* Payment Status */}
              {venue.paid_amount > 0 && (
                <div className="payment-status paid">Paid: {formatCurrency(venue.paid_amount)}</div>
              )}
              {venue.balance_to_be_paid > 0 && (
                <div className="payment-status balance">Balance: {formatCurrency(venue.balance_to_be_paid)}</div>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  // ============================================
  // PRIEST CASE
  // ============================================
  if (serviceType === "Priest") {
    return (
      <div className="Order_service-card">
        {data.map((priest, idx) => (
          <div key={idx} className="Order_service-item">
            <div className="order_headder">
              <span className="providername">{priest.priest?.name || "Priest"}</span>
              <div className="cancleblock">
                <div style={{ position: "relative" }}>
                  <Button
                    icon="pi pi-ellipsis-v"
                    className="p-button-rounded p-button-text"
                    style={{ backgroundColor: "#fff", color: "#000", border: "1px solid #ccc" }}
                    onClick={() =>
                      setOpenMenuRow(openMenuRow === priest.priest?.id ? null : priest.priest?.id)
                    }
                  />
                  {openMenuRow === priest.priest?.id && (
                    <div
                      className="dropdownContainer"
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: 0,
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "5px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        zIndex: 100,
                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      }}
                    >
                      <button
                        className="cancel-btn"
                        onClick={() => {
                          onCancel({ eventId, provider_id: priest.priest?.id, serviceType });
                          setOpenMenuRow(null);
                        }}
                      >
                        <i className="pi pi-times"></i> Cancel
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="footer">
              <span></span>
              <span className="Bill_total">Bill Total {formatCurrency(priest.total_amount)}</span>
            </div>
          </div>
        ))}
      </div>
    );
  }

  // ============================================
  // TENT HOUSE CASE
  // ============================================
  if (serviceType === "Tent House") {
    return (
      <div className="Order_service-card">
        {data.map((tent, idx) => {
          const isExpanded = expandedIndexes[idx];
          const visibleItems = isExpanded ? tent.items : tent.items?.slice(0, 2);

          return (
            <div key={idx} className="Order_service-item">
              <div className="order_headder">
                <span className="providername">
                  {tent.first_name} {tent.last_name}
                </span>
                <div className="cancleblock">
                  <div style={{ position: "relative" }}>
                    <Button
                      icon="pi pi-ellipsis-v"
                      className="p-button-rounded p-button-text"
                      style={{ backgroundColor: "#fff", color: "#000", border: "none" }}
                      onClick={() =>
                        setOpenMenuRow(openMenuRow === tent.provider_id ? null : tent.provider_id)
                      }
                    />
                    {openMenuRow === tent.provider_id && (
                      <div
                        className="dropdownContainer"
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: 0,
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "5px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          zIndex: 100,
                          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        }}
                      >
                        <button
                          className="cancel-btn"
                          onClick={() => {
                            onCancel({ eventId, provider_id: tent.provider_id, serviceType });
                            setOpenMenuRow(null);
                          }}
                        >
                          <i className="pi pi-times"></i> Cancel
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {visibleItems?.map((item, i) => (
                <span key={i} className="tentitemslist">
                  {item.mapping?.service?.service_name || "Item"} (x{item.quantity})
                </span>
              ))}
              {tent.items?.length > 2 && (
                <button onClick={() => toggleExpand(idx)} className="expand-btn">
                  {isExpanded ? "Show Less" : `+${tent.items.length - 2} more`}
                </button>
              )}
              <div className="footer">
                <span></span>
                <span className="Bill_total">Bill Total {formatCurrency(tent.total_amount)}</span>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  // ============================================
  // CATERING CASE
  // ============================================
  if (serviceType === "Catering") {
    return (
      <div className="Order_service-card">
        {data.map((cater, idx) => {
          const isveg = cater.items?.[0]?.category?.category_name === "Vegetarian";
          const categoryImage = isveg ? veglabel : nonveg;
          
          return (
            <div key={idx} className="Order_service-item">
              <div className="cateringheader">
                <span className="providername">
                  {cater.first_name} {cater.last_name}
                </span>
                <div className="cancleblock">
                  <div className="icon image">
                    <img src={categoryImage} alt="Category Icon" className="categoryIcon" />
                  </div>
                  <div style={{ position: "relative" }}>
                    <Button
                      icon="pi pi-ellipsis-v"
                      className="p-button-rounded p-button-text"
                      style={{ backgroundColor: "#fff", color: "#000", border: "none", padding: "1px" }}
                      onClick={() =>
                        setOpenMenuRow(openMenuRow === cater.provider_id ? null : cater.provider_id)
                      }
                    />
                    {openMenuRow === cater.provider_id && (
                      <div
                        className="dropdownContainer"
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: 0,
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "5px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          zIndex: 100,
                          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        }}
                      >
                        <button
                          className="cancel-btn"
                          onClick={() => {
                            onCancel({ eventId, provider_id: cater.provider_id, serviceType });
                            setOpenMenuRow(null);
                          }}
                        >
                          <i className="pi pi-times"></i> Cancel
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {cater.items?.map((dish, i) => (
                <span key={i} className="cateringitemslist">
                  {dish.meal?.meal_name || "Meal"} ({dish.type?.type_name || "N/A"})
                  {dish.mapping?.regular_price && ` - ${formatCurrency(dish.mapping.regular_price)}`}
                  <span>Total people: {dish.number_of_people}</span>
                </span>
              ))}
              <div className="footer">
                <span></span>
                <span className="Bill_total">Bill Total {formatCurrency(cater.total_amount)}</span>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  return null;
};

export default Ordercard;